import React, { useEffect } from "react";  

import Header from 'components/Landpage/Header'
import Footer from 'components/Landpage/Footer' 

import { 
    Content
} from "./styled"; 
import { ThemedComponent } from "ui/theme";

export default function ContainerLandpage({ children, variant = "nursing" }){ 
    useEffect(() => { window.scrollTo(0,0) ;},[])
    const themeKey = variant === "aesthetics" ? "jadePastel" : "nursing";
    return ( 
        <ThemedComponent themeKey={themeKey}>
            <Content>
                <Header variant={variant} />
                    { children }
                <Footer variant={variant} /> 
            </Content>
        </ThemedComponent>
    );
}
